<template>
  <v-flex v-if="pendingRefresh" grow>
    <v-alert
      :value="pendingRefresh"
      type="info"
      class="text-xs-left primary--text ma-0"
      outline
    >
      A new version is available.
      <a class="update-link" @click="refreshPage">Refresh</a> to load the latest
      changes.
    </v-alert>
    <v-dialog v-model="showRefreshDialog" persistent max-width="290">
      <v-card>
        <v-tooltip bottom>
          <template slot="activator">
            <v-card-title class="headline pb-0">
              New version available
              <v-icon size="15" class="ml-1"> help_outline </v-icon>
            </v-card-title>
          </template>
          <span>Click update button to get the latest version.</span>
        </v-tooltip>
        <v-card-actions>
          <v-spacer />
          <v-btn class="primary text-none" @click="refreshPage"> Update </v-btn>
          <v-btn class="error--text text-none" flat @click="ignoreUpdate">
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-flex>
</template>

<script>
import firebase from 'firebase';

export default {
  name: 'RefreshUiAlert',
  data() {
    return {
      uiVersion: null,
      showRefreshDialog: false,
      pendingRefresh: false,
    };
  },
  methods: {
    refreshPage() {
      window.location.reload();
    },
    ignoreUpdate() {
      this.showRefreshDialog = false;
      this.$emit('showAlert');
      this.pendingRefresh = true;
    },
    initUiVersionListener() {
      const database = firebase.database();
      const uiVersionCountRef = database.ref('ui');
      uiVersionCountRef.on('value', snapshot => {
        const data = snapshot.val();

        if (this.uiVersion && this.uiVersion !== data.version) {
          this.showRefreshDialog = true;
        }

        this.uiVersion = data.version;
      });
    },
  },
  created() {
    this.initUiVersionListener();
  },
};
</script>
